// GENERATED from server/lib/messages/core.js by scripts/gen-message-core.js.
// Do not edit by hand: edit the server copy and run the script. The block
// between the markers must stay byte for byte the same on both sides (a
// clicked send renders here, and the server honours that text);
// server/lib/messages/core.test.js fails when they drift.

// CORE:BEGIN
const SOURCES = ['partner', 'event', 'website', 'referral', 'called'];

const SOURCE_LABEL = {
  partner: 'A partner',
  event: 'An event',
  website: 'Our website',
  referral: 'Referred by someone',
  called: 'They called us',
};

// Every fill-in. `source` = only that source can fill it (its name).
// `blocking` = with no value it stays as typed and the send is refused.
// `aliases` = the old cadence [bracket] forms, read forever.
const FILL_INS = [
  { key: 'first_name', label: 'first name', aliases: ['[lead first name]', '[client first name]'], sample: 'Tracey', hint: 'Their first name ("there" when we have none)' },
  { key: 'my_name', label: 'my name', aliases: ['[support first name]', '[user first name]', '[internal user first name]'], sample: 'Kit', hint: 'Who it comes from (for an automated email, whoever owns them)' },
  { key: 'bio', label: 'bio', aliases: ['[bio]'], blocking: true, sample: 'Kit is an Army veteran who helps fellow veterans with their VA ratings every day.', hint: "The sender's bio, from their call profile" },
  { key: 'owner_phone', label: 'owner phone', aliases: ['[assignee number]'], blocking: true, sample: '(615) 263-9391', hint: 'The phone number of whoever owns them' },
  { key: 'partner_name', label: 'partner name', aliases: [], source: 'partner', blocking: true, sample: 'Marcus Bennett', hint: "The partner who sent them: the site they used (Envoy's leads say VeteranRelief.org), else the partner's name" },
  { key: 'event_name', label: 'event name', aliases: [], source: 'event', blocking: true, sample: 'SMDS - Huntsville', hint: 'The event where they signed up' },
  { key: 'referrer_name', label: 'referrer name', aliases: [], source: 'referral', blocking: true, sample: 'Lena Reyes', hint: 'The person who referred them' },
  { key: 'meeting_time', label: 'meeting time', aliases: [], sample: 'tomorrow at 2:00 PM Central', hint: 'When their meeting is' },
  { key: 'meeting_type', label: 'meeting type', aliases: [], sample: 'call', hint: '"call" or "video meeting"' },
  { key: 'how_we_meet', label: 'how we meet', aliases: [], sample: "I'll call you at (352) 555-0100.", hint: 'Phone: "I\'ll call you at (their number)." Video: "Join here: (the join link)"' },
  { key: 'old_meeting_time', label: 'old meeting time', aliases: [], sample: 'Mon, Oct 27 at 10:00 AM CDT', hint: 'When it was before it moved' },
  // Who has them now, when a meeting is canceled because they moved on
  // (Nic 2026-10-26). Blocking: with nobody to name, the plain cancel goes.
  { key: 'new_contact', label: 'new contact', aliases: [], blocking: true, sample: 'Kit Phillips', hint: 'Who they work with now: their Onboarding Specialist, Claims Manager or new rep' },
  { key: 'new_contact_phone', label: 'new contact phone', aliases: [], blocking: true, sample: '(615) 263-9391', hint: "That person's phone number (the company line when they have none)" },
  { key: 'meeting_details', label: 'meeting details', aliases: [], sample: '[The meeting card: when, phone or video, and the Join button]', hint: 'The meeting card: when, phone or video, and the Join button' },
  { key: 'signup_link', label: 'signup link', aliases: [], sample: 'https://app.veritasratings.com/register?i=…', hint: 'Their link to create an account' },
  { key: 'sign_in_link', label: 'sign-in link', aliases: [], sample: 'https://app.veritasratings.com/processing', hint: 'Where they sign in to review and sign' },
  { key: 'dashboard_link', label: 'dashboard link', aliases: [], sample: 'https://app.veritasratings.com/dashboard', hint: 'Their portal' },
  { key: 'referral_link', label: 'referral link', aliases: [], sample: 'https://app.veritasratings.com/referral', hint: 'Our referral program page' },
  // The Removing POA email's form (Nic 2026-10-27). Blocking: the email is
  // the form's delivery.
  { key: 'form_link', label: 'form link', aliases: [], blocking: true, sample: 'https://app.veritasratings.com/forms/va-form-21-4138-revoke-poa.pdf', hint: 'The VA form to revoke their POA, already filled in' },
  { key: 'va_gov_link', label: 'VA.gov link', aliases: [], sample: 'https://www.va.gov/resources/creating-an-account-for-vagov/', hint: "VA.gov's guide to making an account and signing in" },
  { key: 'missing', label: "what they're getting", aliases: [], sample: 'your DD-214 and private treatment records', hint: 'What we marked Client is getting it, up to four' },
];

// The old one-size source fill-in, read forever and never offered: it says
// the source's name (the partner, the event, the referrer, "our website").
const SOURCE_NAME_ALIASES = ['[referral source]'];
const SOURCE_NAME_BRACE = /\{\s*referral\s+source\s*\}/gi;

// Which fill-in carries each source's name.
const SOURCE_FILL_IN = { partner: 'partner_name', event: 'event_name', referral: 'referrer_name' };

const escapeRe = (s) => String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
// {first name}, {  First Name }: any case, any spaces inside the braces.
const braceSource = (label) => `\\{\\s*${escapeRe(label).replace(/ /g, '\\s+')}\\s*\\}`;
const bracePattern = (label) => new RegExp(braceSource(label), 'gi');

const fillInByKey = (key) => FILL_INS.find((f) => f.key === key) || null;

// A source name lands in a message, and for partner leads it is partner
// supplied text (site_name), so it is tidied and capped.
const MAX_NAME = 80;
const cleanName = (value) => {
  const s = String(value || '')
    .replace(/\s+/g, ' ')
    .trim();
  if (!s) return null;
  return s.length > MAX_NAME ? s.slice(0, MAX_NAME).trim() : s;
};

// The umbrella partner every self-referral shares: plumbing, never a source.
const REFERRAL_UMBRELLA_SLUG = 'referral-program';
const REFERRAL_UMBRELLA_NAME = 'referral program';
const isUmbrella = (lead) =>
  String(lead?.partnerReferralUrl || '').toLowerCase() === REFERRAL_UMBRELLA_SLUG ||
  String(lead?.partnerName || '')
    .trim()
    .toLowerCase() === REFERRAL_UMBRELLA_NAME;

const referrerNameOf = (lead) => {
  const r = (lead?.leadMeta || {}).referredBy;
  if (r && typeof r === 'object') return cleanName(`${r.firstName || ''} ${r.lastName || ''}`);
  if (typeof r === 'string') return cleanName(r);
  return null;
};

// The phrases the old manual add stored as siteName.
const OLD_PHRASE = {
  website: ['website', 'our website'],
  called: ['your call with our team'],
  event: ['one of our events'],
};
const isPhrase = (site, kind) => !!site && OLD_PHRASE[kind].includes(site.toLowerCase());

/**
 * Where this lead came from: { kind, id, name }. Never unknown: a lead that
 * matches nothing is counted as our website (and the caller can log it).
 * `id` is the partner's id for a partner or an event (for their own wording).
 * First match wins:
 *   1. a person referred them (the referral form; the 4 old umbrella leads
 *      from before we asked for the name read "someone you know")
 *   2. an event partner, or an old import / manual add that names an event
 *   3. any other partner
 *   4. a rep added them after they called
 *   5. our website (the form, web imports, and the safety net)
 */
const sourceOf = (lead) => {
  if (!lead) return null;
  const meta = lead.leadMeta || {};
  const site = cleanName(meta.siteName);
  const referrer = referrerNameOf(lead);
  if (referrer) return { kind: 'referral', id: null, name: referrer };
  if (lead.leadPartnerId && isUmbrella(lead)) return { kind: 'referral', id: null, name: 'someone you know' };
  // A partner's site name is the name they know it by (Envoy sends
  // "VeteranRelief.org"); the partner's own name otherwise.
  const siteName = site && !isPhrase(site, 'website') && site.toLowerCase() !== REFERRAL_UMBRELLA_NAME ? site : null;
  if (lead.leadPartnerId && lead.partnerType === 'event') {
    return { kind: 'event', id: lead.leadPartnerId, name: siteName || cleanName(lead.partnerName) || 'one of our events' };
  }
  if (lead.leadPartnerId) {
    return { kind: 'partner', id: lead.leadPartnerId, name: siteName || cleanName(lead.partnerName) || 'our partner' };
  }
  if (meta.manualSource === 'call' || meta.manualSource === 'other' || isPhrase(site, 'called')) {
    return { kind: 'called', id: null, name: null };
  }
  if (meta.manualSource === 'event' || isPhrase(site, 'event')) {
    return { kind: 'event', id: null, name: 'one of our events' };
  }
  const web =
    isPhrase(site, 'website') ||
    meta.manualSource === 'website' ||
    lead.leadSource === 'web' ||
    lead.leadSourceSystem === 'reach-out';
  // An old import that names a place (Tyndall AFB, the SOA Reunion) met
  // them at that event.
  if (!web && site && lead.leadSourceSystem === 'jorge-import') return { kind: 'event', id: null, name: site };
  return { kind: 'website', id: null, name: null, ...(web ? {} : { guessed: true }) };
};

/** The source's name, for the old one-size [referral source] fill-in. */
const sourceNameOf = (source) => {
  if (!source) return null;
  if (source.kind === 'website') return 'our website';
  if (source.kind === 'called') return 'your call with our team';
  return source.name || null;
};

/** The fill-in values a source gives: its name, under its own fill-in. */
const sourceValues = (source) => {
  const out = { source_name: sourceNameOf(source) };
  if (source && SOURCE_FILL_IN[source.kind]) out[SOURCE_FILL_IN[source.kind]] = source.name;
  return out;
};

/**
 * Fill in a wording. `values` is keyed by fill-in key (first_name, ...), plus
 * source_name for the old [referral source]. A blocking fill-in with no value
 * stays as typed (the send paths refuse it); any other becomes its value or
 * nothing. Replacement is literal (a $ in a value is just a $).
 */
const fill = (text, values = {}) => {
  if (!text) return '';
  let out = String(text);
  FILL_INS.forEach((f) => {
    const raw = values[f.key];
    const has = raw !== undefined && raw !== null && String(raw) !== '';
    if (!has && f.blocking) return;
    const value = has ? String(raw) : '';
    out = out.replace(bracePattern(f.label), () => value);
    f.aliases.forEach((alias) => {
      out = out.split(alias).join(value);
    });
  });
  const name = values.source_name;
  if (name) {
    out = out.replace(SOURCE_NAME_BRACE, () => name);
    SOURCE_NAME_ALIASES.forEach((alias) => {
      out = out.split(alias).join(name);
    });
  }
  return out;
};

/** The blocking fill-ins still in a text (nothing filled them). */
const unfilled = (text) => {
  const s = String(text || '');
  const left = FILL_INS.filter(
    (f) => f.blocking && (new RegExp(braceSource(f.label), 'i').test(s) || f.aliases.some((a) => s.includes(a))),
  ).map((f) => f.key);
  if (SOURCE_NAME_ALIASES.some((a) => s.includes(a)) || new RegExp(SOURCE_NAME_BRACE.source, 'i').test(s)) left.push('source_name');
  return left;
};

/** Braces that aren't fill-ins at all (a typo). */
const unknownFillIns = (text) => {
  const found = String(text || '').match(/\{[^{}]{1,40}\}/g) || [];
  const known = (s) =>
    FILL_INS.some((f) => new RegExp(`^${braceSource(f.label)}$`, 'i').test(s)) ||
    new RegExp(`^${SOURCE_NAME_BRACE.source}$`, 'i').test(s);
  return [...new Set(found.filter((s) => !known(s)))];
};

/** Does a text use this fill-in (braces or an old alias)? */
const usesFillIn = (text, key) => {
  const f = fillInByKey(key);
  if (!f) return false;
  const s = String(text || '');
  return new RegExp(braceSource(f.label), 'i').test(s) || f.aliases.some((a) => s.includes(a));
};

/**
 * Which wording this person gets: their partner's or event's own wording,
 * else their source's. One wording for everyone when the message has one.
 * { key, subject, body } or null. An own wording with no subject uses its
 * source's subject.
 */
const pickWording = (message, source) => {
  if (!message) return null;
  const w = message.wordings || {};
  if (message.mode === 'one') return w.all ? { key: 'all', subject: w.all.subject || null, body: w.all.body || '' } : null;
  if (!source) return null;
  const base = w[source.kind] || null;
  const ownKey = source.id ? `${source.kind}:${source.id}` : null;
  const own = ownKey ? w[ownKey] : null;
  if (own && String(own.body || '').trim()) {
    return { key: ownKey, subject: (own.subject && own.subject.trim()) || base?.subject || null, body: own.body };
  }
  return base ? { key: source.kind, subject: base.subject || null, body: base.body || '' } : null;
};

/** Characters and text segments (160 plain, 70 with emoji or curly marks). */
const smsSegments = (text) => {
  const s = String(text || '');
  const unicode = [...s].some((c) => c.charCodeAt(0) > 127);
  const per = unicode ? 70 : 160;
  const multi = unicode ? 67 : 153;
  return { length: s.length, segments: s.length <= per ? 1 : Math.ceil(s.length / multi) };
};
// CORE:END

export {
  SOURCES,
  SOURCE_LABEL,
  FILL_INS,
  SOURCE_FILL_IN,
  SOURCE_NAME_ALIASES,
  REFERRAL_UMBRELLA_SLUG,
  REFERRAL_UMBRELLA_NAME,
  fillInByKey,
  cleanName,
  isUmbrella,
  referrerNameOf,
  sourceOf,
  sourceNameOf,
  sourceValues,
  fill,
  unfilled,
  unknownFillIns,
  usesFillIn,
  pickWording,
  smsSegments,
};
